import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MensagemSucesso = ({ open, handleClose, msg }) => {
  // Garantir que msg seja sempre uma string
  const message =
    typeof msg === "string"
      ? msg
      : typeof msg === "object" && msg !== null
      ? JSON.stringify(msg)
      : String(msg || "Operação realizada com sucesso!");

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity="success">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MensagemSucesso;
